import i18n from 'i18next';

import { FetchService } from '@izimi/api';
import { getUserFromStorage, logout } from '@izimi/auth';

import config, { appSpec } from '../config';

export const fetchService = new FetchService({
  getAccessToken: () => Promise.resolve(getUserFromStorage()?.access_token),
  getLanguage: () => i18n.language,
  getAppSpec: () => appSpec,
  handleErrorResponse(res) {
    const isForbiddenOrUnauthorized = res.status === 401 || res.status === 403;

    // server side
    if (typeof window === 'undefined') {
      return Promise.reject(res);
    }

    if (isForbiddenOrUnauthorized) {
      logout();
      return Promise.reject(res);
    }

    if ('readyState' in res) {
      // this is the response of XMLHttpRequests errors (upload document)
      try {
        return JSON.parse(res.response);
      } catch {
        return res.response;
      }
    }

    return Promise.reject(res);
  },
  logRequests: import.meta.env.DEV,
});

fetchService.setApiUrl(import.meta.env.DEV ? `/api` : `${config.apiUrl}/api`);
